import React from 'react';
import './paragraph.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Paragraph = props => {
    const {
        children,
        fontSize,
        fontWeight,
        colorScheme,
        textAlign,
        verticalAlign,
        withSpacing,
        withIndent,
    } = props;

    const textClasses = classNames({
        text: true,
        'text__font-size--small': fontSize === 'small',
        'text__font-size--large': fontSize === 'large',
        'text__font-size--x-large': fontSize === 'x-large',
        'text__font-weight--bold': fontWeight === 'bold',
        'text__color--dark': colorScheme === 'dark',
    });

    const textContainerClasses = classNames({
        'text-container': true,
        'text-container--spacing-false': !withSpacing,
        'text-container--indent-true': withIndent,

        'text-container--text-align-center': textAlign === 'center',
        'text-container--vertical-align-top': verticalAlign === 'top',
    });

    return (
        <div className={textContainerClasses}>
            <p className={textClasses}>{children}</p>
        </div>
    );
};

Paragraph.defaultProps = {
    fontSize: 'medium',
    fontWeight: 'normal',
    colorScheme: 'light',
    textAlign: 'left',
    verticalAlign: 'middle',
    withSpacing: true,
    withIndent: false,
};

Paragraph.propTypes = {
    fontSize: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
    fontWeight: PropTypes.oneOf(['normal', 'bold']),
    colorScheme: PropTypes.oneOf(['light', 'dark']),
    textAlign: PropTypes.oneOf(['left', 'center']),
    verticalAlign: PropTypes.oneOf(['middle', 'top']),
    withSpacing: PropTypes.bool,
    withIndent: PropTypes.bool,
};

export { Paragraph };
